import {Group, SphereGeometry, Mesh, MeshBasicMaterial, Vector4, Vector3 } from 'three';
import PointsHelper                                                        from './CubeHelper';
import SceneVisualBase                                                     from './SceneVisualObjectBase';

const xDots = [];
const yDots = [];
const zDots = [];
// let group = new THREE.Group();
const pointsColor = 0xffffff;
const pointsColorOpacity = 0.3;

const pointsHighlightColor = 0xff0000
const pointsHighlightColorOpacity = 1;

export default class Cube extends SceneVisualBase {
  constructor(cameraManager, pointGeometry) {
    super(cameraManager)
    this.cubeEdgeLength = 1,
    this.startCubePos;
    this.pointGeometry = pointGeometry,
    this.group = new Group(),
    this.group.name = 'cubeGroup',
    this.add(this.group)
    this.sizes = [10,20,30,40,50,100,150,200,250,300,400,500,600,700,800,900,1000,1500,2000,2500,3500,4000,4500,5000,6000,7000,8000,9000,10000,15000,20000,25000,30000,35000,40000,45000,50000],
    this.iterator = 11,
    this.size = this.sizes[this.iterator]

    this.pointDefaultMaterial = new MeshBasicMaterial({
      color: pointsColor,
      opacity: pointsColorOpacity,
      transparent: true,
    });
    this.pointHighlightedMaterial = new MeshBasicMaterial({
      color: pointsHighlightColor,
      opacity: pointsHighlightColorOpacity,
      transparent: true,
    });

    this.cubeVertex(this.cubeEdgeLength);
  }

  cubeVertex(n) {
    const l = n / 45
    xDots.push(
        new Vector4(0, n, 0, {
          angle: 0
        }),
        new Vector4(l * 5, n, 0, {
          angle: 5
        }),
        new Vector4(l * 10, n, 0, {
          angle: 10
        }),
        new Vector4(l * 20, n, 0, {
          angle: 20
        }),
        new Vector4(l * 30, n, 0, {
          angle: 30
        }),
        new Vector4(l * 40, n, 0, {
          angle: 40
        }),
        new Vector4(n, n, 0, {
          angle: 45
        }),
        new Vector4(n, l * 40, 0, {
          angle: 40
        }),
        new Vector4(n, l * 30, 0, {
          angle: 30
        }),
        new Vector4(n, l * 20, 0, {
          angle: 20
        }),
        new Vector4(n, l * 10, 0, {
          angle: 10
        }),
        new Vector4(n, l * 5, 0, {
          angle: 5
        }),
        new Vector4(n, 0, 0, {
          angle: 0
        })),
      zDots.push(
        new Vector4(0, 0, n, {
          angle: 0
        }),
        new Vector4(l * 5, 0, n, {
          angle: 5
        }),
        new Vector4(l * 10, 0, n, {
          angle: 10
        }),
        new Vector4(l * 20, 0, n, {
          angle: 20
        }),
        new Vector4(l * 30, 0, n, {
          angle: 30
        }),
        new Vector4(l * 40, 0, n, {
          angle: 40
        }),
        new Vector4(n, 0, n, {
          angle: 45
        }),
        new Vector4(n, 0, l * 40, {
          angle: 40
        }),
        new Vector4(n, 0, l * 30, {
          angle: 30
        }),
        new Vector4(n, 0, l * 20, {
          angle: 20
        }),
        new Vector4(n, 0, l * 10, {
          angle: 10
        }),
        new Vector4(n, 0, l * 5, {
          angle: 5
        })),
      yDots.push(
        new Vector4(0, n, l * 5, {
          angle: 5
        }),
        new Vector4(0, n, l * 10, {
          angle: 10
        }),
        new Vector4(0, n, l * 20, {
          angle: 20
        }),
        new Vector4(0, n, l * 30, {
          angle: 30
        }),
        new Vector4(0, n, l * 40, {
          angle: 40
        }),
        new Vector4(0, n, n, {
          angle: 45
        }),
        new Vector4(0, l * 40, n, {
          angle: 40
        }),
        new Vector4(0, l * 30, n, {
          angle: 30
        }),
        new Vector4(0, l * 20, n, {
          angle: 20
        }),
        new Vector4(0, l * 10, n, {
          angle: 10
        }),
        new Vector4(0, l * 5, n, {
          angle: 5
        })),
    this.setCubeMeshes();
  }

  setCubeMeshes() {
    const material = this.pointDefaultMaterial;
    const centerPoint = new Mesh(new SphereGeometry(0.3, 32, 32), 
      material);
    centerPoint.name = '0,0,0';
    this.group.add(centerPoint);

    xDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y, i.z);
      this.group.add(sphere);
    });

    xDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x * -1, i.y, i.z);
      this.group.add(sphere);
    });

    xDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y * -1, i.z);
      this.group.add(sphere);
    });

    xDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x * -1, i.y * -1, i.z);
      this.group.add(sphere);
    });
    // ----------------------------//
    zDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y, i.z);
      this.group.add(sphere);
    });

    zDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x * -1, i.y, i.z * -1);
      this.group.add(sphere);
    });

    zDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y, i.z * -1);
      this.group.add(sphere);
    });
    zDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x * -1, i.y * -1, i.z);
      this.group.add(sphere);
    });
    // ---------------------------//
    yDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y, i.z);
      this.group.add(sphere);
    });

    yDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y * -1, i.z);
      this.group.add(sphere);
    });
    yDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y, i.z * -1);
      this.group.add(sphere);
    });

    yDots.forEach(i => {
      const sphere = new Mesh(this.pointGeometry, material);
      sphere.name = i.w.angle;
      sphere.position.set(i.x, i.y * -1, i.z * -1);
      this.group.add(sphere);
    });
    this.startCubePos = this.group.children.map(i => i.position.clone())
    this.scaleSize(this.size)
    return this.group;
  }
  
  getCubeSize(delta){
    if(delta < 0) {
      this.iterator < this.sizes.length-1 ? this.iterator ++ : this.sizes.length-1
    }
    if(delta > 0) {
      this.iterator > 0 ? this.iterator-- : 0
    }
    this.scaleSize()
    return this.sizes[this.iterator]
  }

  scaleSize() {
      this.group.children.forEach((item, i) => {
          item.position.copy(this.startCubePos[i].clone().multiplyScalar(this.sizes[this.iterator]))
      })
  }

  setPointHighlight(pointMesh, highlighted) {
    if(pointMesh.parent !== this.group){
      console.error('not this group parent')
      return
    }
    if (highlighted) {
      pointMesh.material = this.pointHighlightedMaterial
    } else {
      pointMesh.material = this.pointDefaultMaterial
    }
  }

  raycastPoint(mouse) {
    return this.raycaster.getObjects(mouse, this.group.children)
  }
}
